import { render, staticRenderFns } from "./BaseTLList.vue?vue&type=template&id=5da044bf&"
import script from "./BaseTLList.vue?vue&type=script&lang=ts&"
export * from "./BaseTLList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports